import { Box } from '@mui/material';
import { FC } from 'react';
import SectionHeader from '@/components/section-header';

interface Props {
  title: string;
}

const ConnectorStepHeader: FC<Props> = ({ title }) => {
  return (
    <Box my={2}>
      <SectionHeader title={title} />
    </Box>
  );
};

export default ConnectorStepHeader;
